// extracted by mini-css-extract-plugin
export var hrWhite = "hr-module--hr-white--Gjw7k";
export var hrBlack = "hr-module--hr-black--2FbDY";
export var hrWheat = "hr-module--hr-wheat--3SAeB";
export var hrWheatFull = "hr-module--hr-wheat-full--XwAdJ";
export var hrLight = "hr-module--hr-light--3PWRj";
export var hrLightFull = "hr-module--hr-light-full--1_mf4";